import { createOrganizer } from "api/company.api";
import OrganizerForm from "components/company/OrganizerForm";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { organizerRoute } from "../../../utils/permissionRoute";
export default function CreateOrganizer() {
  const navigate = useNavigate();
  const [alert, setAlert] = useState("");

  const handleSubmit = async (data) => {
    try {
      // const formData = new FormData();

      // Object.entries(data).forEach(([key, value]) => {
      //   if (key === "projectModules") {
      //     value.forEach((module) =>
      //       formData.append("projectModules[]", module)
      //     );
      //   } else if (key === "companyLogo" && value instanceof File) {
      //     formData.append("companyLogo", value);
      //   } else if (value !== null && value !== "") {
      //     formData.append(key, value);
      //   } else if (key === "staffDetails") {
      //     formData.append(
      //       "staffDetails",
      //       JSON.stringify(data.staffDetails || [])
      //     );
      //   }
      // });
      // console.log(   "staffDetails",
      //       JSON.stringify(data.staffDetails || []))
      // console.log("handleSubmit,formData",formData)
      // await createOrganizer(formData);
      // navigate("/admin/companies");
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        // 1. Check staffDetails FIRST (convert Array of objects to JSON string)
        if (key === "staffDetails") {
          formData.append("staffDetails", JSON.stringify(value || []));
        } else if (key === "ticketDiscounts") {
          formData.append("ticketDiscounts", JSON.stringify(value || []));
        } else if (key === "ticketPriceTiers") {
          formData.append("ticketPriceTiers", JSON.stringify(value || []));
        }
        // 2. Check communicationEmails (convert Array to JSON string)
        else if (key === "communicationEmails") {
          formData.append("communicationEmails", JSON.stringify(value || []));
        } else if (key === "eventHighlights") {
          formData.append("eventHighlights", JSON.stringify(value || []));
        }
        // 3. Check projectModules
        else if (key === "projectModules" && Array.isArray(value)) {
          formData.append("projectModules", JSON.stringify(value || []));
        } else if (key === "eventTimings" && Array.isArray(value)) {
          formData.append("eventTimings", JSON.stringify(value || []));
        } else if (key === "eventFeatures" && Array.isArray(value)) {
          formData.append("eventFeatures", JSON.stringify(value || []));
        } else if (key === "whyParticipate" && Array.isArray(value)) {
          formData.append("whyParticipate", JSON.stringify(value || []));
        } else if (key === "hospitalitySection" && Array.isArray(value)) {
          formData.append(
            "hospitalitySection",
            JSON.stringify(data.hospitalitySection || {})
          );
        }

        // 4. Check File upload
        else if (key === "companyLogo" && value instanceof File) {
          formData.append("companyLogo", value);
        }
        // 5. General primitive values LAST
        else if (value !== null && value !== "" && value !== undefined) {
          formData.append(key, value);
        } else if (key === "sponsorImages" && Array.isArray(value)) {
          // Append each sponsor image file or string (for existing ones)
          value.forEach((img) => {
            formData.append("sponsorImages", img);
          });
        }
      });

      //   // 1. Convert JSON array fields
      // formData.append("eventFeatures", JSON.stringify(data.eventFeatures || []));
      // formData.append("whyParticipate", JSON.stringify(data.whyParticipate || []));

      // ... append other JSON fields ...

      // 2. Append feature logos (binary files)
      (data.eventFeatures || []).forEach((feat) => {
        if (feat.logo instanceof File) {
          formData.append("featureLogos", feat.logo);
        }
      });
      if (data.hospitalitySection?.image instanceof File) {
        formData.append("hospitalityImage", data.hospitalitySection.image);
      }

      // 🔍 Correct way to log FormData contents
      console.log("FormData Entries:", Object.fromEntries(formData.entries()));

      await createOrganizer(formData);
      navigate("/admin/companies");
    } catch (err) {
      console.error("API ERROR:", err.response?.data || err.message);
      setAlert(
        err.response?.data?.message || "Something went wrong. Try again."
      );
    }
  };

  return (
    <OrganizerForm
      onSubmit={handleSubmit}
      submitLabel="Create Organizer"
      alert={alert}
      setAlert={setAlert}
      onBack={() => navigate(-1)}
      organizerRoute={organizerRoute}
    />
  );
}
